import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="webhook-secret-reveal"
export default class extends Controller {
  static targets = ["secret"]

  copy() {
    const input = this.secretTarget;
    input.select();
    input.setSelectionRange(0, 999_999);
    navigator.clipboard.writeText(input.value).then(() => {
      this.flash(window.I18n["views.webhooks.secret_flash.copied"]);
    }).catch(() => {
      this.flash(window.I18n["views.webhooks.secret_flash.copy_failed"]);
    });
  }

  flash(message) {
    const button = this.element.querySelector("button[data-action]");
    if (!button) return;
    const original = button.textContent;
    button.textContent = message;
    setTimeout(() => { button.textContent = original; }, 2000);
  }
}
